import {MessagingRole} from 'Users/models/User/MessagingUserType';

export class AdminUserType {
  public readonly key = 'AdminUserType';
  public readonly messagingRole = MessagingRole.Admin;
}
